import { bl_fi_my_einvoice_individual_pool_doc_hdr_RowClass } from '../../dbschema/bl_fi_my_einvoice_individual_pool_doc_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceIndividualPoolDocHdrContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_individual_pool_doc_hdr: bl_fi_my_einvoice_individual_pool_doc_hdr_RowClass = new bl_fi_my_einvoice_individual_pool_doc_hdr_RowClass();
}
